import { ReactElement } from 'react';

import { JabraFocusItem } from '../../JabraFocus';
import { ScopedStyle } from '../../ScopedStyle/ScopedStyle';
import { MajorLinkSmallCard } from '../megaMenuTypes';
import {
  CARDS_BG_COLORS,
  getBgBasedColor,
  getRandomBGColor,
  getSmallCardsContainerGridColumnsClass,
} from '../megaMenuUtils';
import { BackgroundImage } from './BackgroundImage';

import styles from './Cards.module.css';

export const SmallCardsGroup = ({
  cards,
}: {
  cards: MajorLinkSmallCard[];
}): ReactElement | null => {
  return (
    <div
      className={`justify-self-starts col-span-1 basis-1/2 auto-rows-fr ${
        styles.gridBase
      } ${getSmallCardsContainerGridColumnsClass(cards.length)}`}
    >
      {cards.map((card) => {
        const cardSettings = card;

        const isBackgroundImageSet =
          !!cardSettings.BackgroundImage?.value?.src ||
          !!cardSettings.backgroundImageExternalLink?.value?.href;
        const bgColor = isBackgroundImageSet ? CARDS_BG_COLORS[1] : getRandomBGColor(card.id);
        const textColor = getBgBasedColor(bgColor);
        return cardSettings.Link ? (
          <ScopedStyle
            key={card.id}
            id={card.id}
            css={cardSettings.Style?.value ?? ''}
            renderItem={(styleLinkingProp) => (
              <JabraFocusItem asChild key={card.id}>
                <a
                  href={cardSettings.Link?.value?.href}
                  className={`no-underline hover:no-underline ${styles.card} ${styles.smallCard} ${bgColor} ${textColor}`}
                  {...styleLinkingProp}
                >
                  {isBackgroundImageSet && (
                    <div className="relative w-[75%] flex-1">
                      <BackgroundImage
                        field={cardSettings.BackgroundImage}
                        externalField={{
                          src: cardSettings.backgroundImageExternalLink?.value?.href,
                          altText: cardSettings.Header?.value,
                        }}
                        cardType="small"
                      />
                    </div>
                  )}
                  <p className={`content-center justify-center ${styles.header}`}>
                    {cardSettings.Header?.value}
                  </p>
                </a>
              </JabraFocusItem>
            )}
          />
        ) : null;
      })}
    </div>
  );
};
